import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const Plus: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M7.14286 16V8.85714H0V7.14286H7.14286V0H8.85714V7.14286H16V8.85714H8.85714V16H7.14286Z" fill="#5F6368" />
    </svg>
  </SvgWrapper>
);
